window.chmDialog = (function() {
    var _chmDialog, CONFIG, dialogStack, $dialogContainer, KEY_HANDLER, suppressNextPopState;

    dialogStack = [];
    suppressNextPopState = false;

    CONFIG = {
        DURATION: {
            SHOW: 300
        }
    };

    KEY_HANDLER = {
        13: '$button_primary',
        27: '$button_secondary'
    };

    function stackHide() {
        dialogStack.forEach(dialog => {
            dialog.hide();
        });
    }

    function pushDialogHistoryEntry() {
        var depth;

        depth = (history.state && (typeof history.state.depth === 'number')) ? history.state.depth : 0;
        history.pushState({chmDialog: true, depth: depth + 1}, '', location.href);
    }

    function popDialogHistoryEntry(skipHistory, callback) {
        if (skipHistory || !history.state || !history.state.chmDialog) {
            callback();
            return;
        }

        suppressNextPopState = true;
        window.addEventListener('popstate', callback, {once: true});
        history.back();
    }

    function stackClose() {
        while (dialogStack.length > 0) {
            dialogStack[dialogStack.length - 1].remove(true, true);
        }
    }

    function stackUpdate(autoShow) {
        if (dialogStack.length > 0) {
            if (autoShow !== false) {
                dialogStack[dialogStack.length - 1].show();
            }
            dialogStack.forEach(dialog => {
                dialog.update();
            });
        }
        $dialogContainer.attr('data-dialogs', dialogStack.length);
    }

    function simpleDialog(title, icon, color, message, buttonLabel) {
        return new Promise(function(resolve) {
            chmDialog({
                title: `<span class="${color}">${icon}</span> ${title}`,
                content: message,
                buttons: [
                    {
                        label: buttonLabel
                    }
                ],
                afterClose: function(fromBack) {
                    if (fromBack) {
                        return;
                    }
                    resolve();
                }
            });
        });
    }

    function updateSize(_interface) {
        let dialogWidth, dialogHeight;

        _interface.$dialog.css({
            width: '',
            height: ''
        });

        dialogWidth = (Math.floor(_interface.$dialog.outerWidth() / 2) * 2);
        dialogHeight = (Math.floor(_interface.$dialog.outerHeight() / 2) * 2);

        // _interface.$dialog.css({
        //     width: `${dialogWidth}px`,
        //     height: `${dialogHeight}px`
        // });

        updateHeight(_interface);
    }

    function updateHeight(_interface) {
        let contentHeight;

        if (_interface.$dialog.attr('data-fixed-height') !== 'yes') {
            return;
        }

        contentHeight = (Math.floor((_interface.$dialog.height() - _interface.$dialog.find('.dialog-title').outerHeight() - _interface.$dialog.find('.dialog-buttons').outerHeight()) / 2) * 2);

        _interface.$dialog.find('.dialog-content').css('height', `${contentHeight}px`);
    }

    _chmDialog = function(options) {
        var _this, _interface, STATUS, ELEMENTS;

        options = $.extend({
            title: false,
            content: '',
            buttons: [],
            centerButtons: false,
            allowActions: false,
            isOverlay: false,
            isPersistant: false,
            large: false,
            forceWidth: false,
            forceHeight: false,
            fixedHeight: false,
            overflow: false,
            alignTop: false,
            paddingTop: true,
            paddingBottom: true,
            paddingTitle: true,
            icon: false,
            typeToFocus: null,
            onShow: function() {},
            onResize: function() {},
            onEnter: null,
            onEscape: null,
            beforeClose: function() { return true; },
            afterClose: function() {}
        }, options);

        STATUS = {
            rendered: false,
            hidden: false,
            keyHandler: {
                13: options.onEnter,
                27: options.onEscape
            }
        };

        ELEMENTS = {
            $dialog: $('<div>').addClass('dialog').attr('tabindex', 0),
            $title: $('<div>').addClass('dialog-title'),
            $icon: $('<div>').addClass('dialog-icon'),
            $content: $('<div>').addClass('dialog-content'),
            $buttons: $('<div>').addClass('dialog-buttons'),
            $button_primary: null,
            $button_secondary: null,
            $button_tertiary: null
        };

        if ((options.buttons !== false) && (options.buttons.length === 0)) {
            options.buttons.push({
                label: __i18n('button/close')
            });
        }

        if (options.isOverlay) {
            options.title = $('<div>').addClass('dialog-title-overlay').append(
                $('<div>').addClass('dialog-title-overlay-content').append(options.title),
                $('<div>').addClass('dialog-title-overlay-close').html('<i class="fa-solid fa-xmark"></i>').on('click', () => {
                    _this.close();
                })
            )
        }

        ELEMENTS.$dialog.attr({
            'data-is-hidden': 'init',
            'data-is-overlay': options.isOverlay ? 'yes' : 'no',
            'data-is-persistant': options.isPersistant ? 'yes' : 'no',
            'data-is-large': options.large ? 'yes' : 'no',
            'data-force-width': options.forceWidth ? 'yes' : 'no',
            'data-force-height': options.forceHeight ? 'yes' : 'no',
            'data-fixed-height': options.fixedHeight ? 'yes' : 'no',
            'data-overflow': options.overflow ? 'yes' : 'no',
            'data-has-icon': options.icon ? 'yes' : 'no',
            'data-center-buttons': options.centerButtons ? 'yes' : 'no',
            'data-align-top': options.alignTop ? 'yes' : 'no',
            'data-padding-top': options.paddingTop ? 'yes' : 'no',
            'data-padding-bottom': options.paddingBottom ? 'yes' : 'no',
            'data-padding-title': options.paddingTitle ? 'yes' : 'no'
        });

        ELEMENTS.$dialog.on('click', function(event) {
            if (!options.allowActions && ($(event.target).closest('[data-trigger-action]').length === 0)) {
                event.stopPropagation();
            }
        });

        _interface = {
            $dialog: ELEMENTS.$dialog,
            hide: function() {
                STATUS.hidden = true;
                _interface.update();
            },
            show: function(isResized) {
                STATUS.hidden = false;
                _interface.update(isResized);
            },
            update: function(isResized) {
                if (!STATUS.rendered) {
                    return;
                }
                ELEMENTS.$dialog.attr('data-is-hidden', STATUS.hidden ? 'yes' : 'no');

                if (isResized) {
                    updateSize(_interface);
                    setTimeout(() => {
                        ScoreTrekBattle.Event.callFunction.call(_this, options.onResize);
                    }, 100);
                    setTimeout(() => {
                        updateSize(_interface);
                    }, CONFIG.DURATION.SHOW + 100);
                }
            },
            remove: function(force, skipHistory, fromBack) {
                return new Promise(resolve => {
                    if (!force && STATUS.hidden) {
                        resolve();
                        return;
                    }

                    if ((ScoreTrekBattle.Event.callFunction.call(_this, options.beforeClose, !!force) === false) && !force) {
                        resolve();
                        return;
                    }

                    dialogStack.pop();
                    _interface.hide();
                    _interface.update();
                    setTimeout(() => {
                        ELEMENTS.$dialog.remove();
                        stackUpdate();
                        popDialogHistoryEntry(skipHistory, () => {
                            ScoreTrekBattle.Event.callFunction.call(_this, options.afterClose, !!fromBack);
                            resolve();
                        });
                    }, CONFIG.DURATION.SHOW);
                });
            },
            // Registers an additional callback to run once this dialog has fully
            // closed (after the close animation), preserving any existing one.
            afterClose: function(onAfterClose) {
                var previousAfterClose = options.afterClose;

                options.afterClose = function(fromBack) {
                    ScoreTrekBattle.Event.callFunction.call(_this, previousAfterClose, fromBack);
                    ScoreTrekBattle.Event.callFunction.call(_this, onAfterClose, fromBack);
                };
            },
            title: function(title) {
                ELEMENTS.$icon.detach();

                if (!title) {
                    ELEMENTS.$title.hide();
                    ELEMENTS.$dialog.prepend(ELEMENTS.$icon);
                    return;
                }

                ELEMENTS.$title.show();
                ELEMENTS.$title.empty().append(
                    title,
                    ELEMENTS.$icon
                );
            },
            render: function() {
                ELEMENTS.$dialog.append(ELEMENTS.$title);

                _interface.title(options.title);

                if (options.icon) {
                    ELEMENTS.$icon.append(options.icon);
                }

                if (options.content) {
                    ELEMENTS.$dialog.append(ELEMENTS.$content.append(options.content));
                }

                if (options.typeToFocus) {
                    ELEMENTS.$dialog.on('keydown', function(event) {
                        var activeElement, $input;

                        if (!event.key || (event.key.length !== 1) || (event.key === ' ') || event.ctrlKey || event.metaKey || event.altKey) {
                            return;
                        }

                        activeElement = document.activeElement;

                        if (activeElement && (activeElement.isContentEditable || $(activeElement).is('input, textarea, select'))) {
                            return;
                        }

                        $input = $(options.typeToFocus);

                        if ($input.is(':visible')) {
                            $input.trigger('focus');
                        }
                    });
                }

                if (options.buttons && (options.buttons.length > 0)) {
                    ELEMENTS.$dialog.append(ELEMENTS.$buttons);
                    options.buttons.forEach(button => {
                        var action, $button;

                        action = button.action;

                        if (!button.primary && !button.tertiary) {
                            button.secondary = true;
                        }

                        button.action = function() {
                            if (ScoreTrekBattle.Event.callFunction(action) !== false) {
                                _this.close();
                            }
                        };

                        $button = chmButton(button, _interface);

                        ['primary', 'secondary', 'tertiary'].forEach(buttonType => {
                            if (button[buttonType] && !ELEMENTS[`$button_${buttonType}`]) {
                                ELEMENTS[`$button_${buttonType}`] = $button;
                            }
                        });

                        ELEMENTS.$buttons.append($button);
                    });

                    if (!ELEMENTS.$button_secondary) {
                        ELEMENTS.$button_secondary = ELEMENTS.$button_tertiary || ELEMENTS.$button_primary;
                    }

                    if (!ELEMENTS.$button_primary) {
                        ELEMENTS.$button_primary = ELEMENTS.$button_secondary;
                    }

                    ELEMENTS.$dialog.on('keydown', function(event) {
                        var keyCode;
                        keyCode = event.which;
                        if (STATUS.keyHandler[keyCode]) {
                            ScoreTrekBattle.Event.callFunction(STATUS.keyHandler[keyCode]());
                        } else if (KEY_HANDLER.hasOwnProperty(keyCode)) {
                            ELEMENTS[KEY_HANDLER[keyCode]].trigger('click');
                        }
                    });
                }
            }
        };

        _this = {
            $buttons: ELEMENTS.$buttons,
            close: function(force) {
                return _interface.remove(force);
            },
            title: function(title) {
                return _interface.title(title);
            },
            triggerButton: function(buttonIndex) {
                ELEMENTS.$buttons.children().eq(buttonIndex).trigger('click');
            },
            find: function(selector) {
                return ELEMENTS.$content.find(selector);
            },
            hideTitle: function(isHidden, quick) {
                ELEMENTS.$title.stop()[(isHidden !== false) ? 'slideUp' : 'slideDown'](quick ? 0 : 300);
            },
            hideButtons: function(isHidden, quick) {
                ELEMENTS.$buttons.stop()[(isHidden !== false) ? 'slideUp' : 'slideDown'](quick ? 0 : 300);
            },
            setMinContentHeight: function(offset) {
                let minHeight;

                minHeight = ELEMENTS.$dialog.height() - ELEMENTS.$title.outerHeight() - ELEMENTS.$buttons.outerHeight() + (offset || 0);
                ELEMENTS.$content.css('min-height', `${minHeight}px`);

                return minHeight;
            },
            beforeClose: function(onBeforeClose) {
                options.beforeClose = onBeforeClose;
            },
            // Runs once this dialog has fully closed. Needed whenever an action
            // opens the next dialog: opening one while this one is still closing
            // leaves both on the stack and the wrong one gets popped.
            afterClose: function(onAfterClose) {
                _interface.afterClose(onAfterClose);
            },
            scrollToTop: function(quick) {
                ELEMENTS.$dialog.stop().animate({
                    scrollTop: 0
                }, quick ? 0 : 300);

                ELEMENTS.$content.stop().animate({
                    scrollTop: 0
                }, quick ? 0 : 300);
            }
        };

        _interface.render();
        _interface.update();
        dialogStack.push(_interface);
        pushDialogHistoryEntry();
        stackHide();
        stackUpdate(false);
        $dialogContainer.append(ELEMENTS.$dialog);
        setTimeout(() => {
            ScoreTrekBattle.Event.callFunction.call(_this, options.onRender);
            ELEMENTS.$dialog.attr('data-is-hidden', 'rendered');
            STATUS.rendered = true;

            setTimeout(() => {
                stackUpdate();
                _interface.update();
                ELEMENTS.$dialog.focus();
                ELEMENTS.$dialog.scrollTop(0);
                _interface.update(true);
                setTimeout(() => {
                    ScoreTrekBattle.Event.callFunction.call(_this, options.onShow);
                }, 0);

            }, 0);
        }, CONFIG.DURATION.SHOW);

        ContextMenu.closeAll();

        return _this;
    };

    $dialogContainer = $('<div>').addClass('dialogs noOverScroll');
    $dialogContainer.on('click', function() {
        if (dialogStack.length === 0) {
            return;
        }
        
        currentDialog = dialogStack[dialogStack.length - 1];

        currentDialog.$dialog.focus();
    });
    window.addEventListener('load', function() {
        $('body').append($dialogContainer);
    });
    stackUpdate();

    _chmDialog.close = function(force) {
        if (dialogStack.length > 0) {
            dialogStack[dialogStack.length - 1].remove(force);
            return true;
        }
        return false;
    };

    _chmDialog.closeAll = function() {
        stackClose();
    };

    _chmDialog.closeTopFromBack = function() {
        if (dialogStack.length === 0) {
            return false;
        }
        dialogStack[dialogStack.length - 1].remove(true, true, true);
        return true;
    };

    _chmDialog.isOpen = function() {
        return dialogStack.length > 0;
    };

    // Runs a callback once the currently topmost dialog has fully closed. If no
    // dialog is open, the callback runs immediately. Lets a handler that fires
    // from within a dialog (e.g. a select picker's change event) defer follow-up
    // dialogs until that dialog is really gone, instead of guessing a delay.
    _chmDialog.afterTopClose = function(callback) {
        if (dialogStack.length === 0) {
            ScoreTrekBattle.Event.callFunction(callback);
            return false;
        }

        dialogStack[dialogStack.length - 1].afterClose(callback);

        return true;
    };

    _chmDialog._consumeSuppressedPopState = function() {
        if (suppressNextPopState) {
            suppressNextPopState = false;
            return true;
        }
        return false;
    };

    _chmDialog.error = function(message, context) {
        if (!message) {
            console.warn('chmDialog.error missing argument: message');
            return;
        }
        return _chmDialog.errorSimple(__i18n(message.message ? `error/${message.message}` : message, context));
    };

    _chmDialog.errorSimple = function(message, title, buttonLabel) {
        return simpleDialog(title || __i18n(`dialog/simple/error`), '<i class="fa-solid fa-triangle-exclamation"></i>', 'color-light-pink', message, buttonLabel || __i18n('button/close'));
    };

    _chmDialog.success = function(message, title, buttonLabel) {
        return simpleDialog(title || __i18n(`dialog/simple/success`), '<i class="fa-solid fa-circle-check"></i>', 'color-green', message, buttonLabel || __i18n('button/close'));
    };

    _chmDialog.warning = function(message, title, buttonLabel) {
        return simpleDialog(title || __i18n(`dialog/simple/warning`), '<i class="fa-solid fa-circle-exclamation"></i>', 'color-yellow', message, buttonLabel || __i18n('button/close'));
    };

    _chmDialog.info = function(message, title, buttonLabel) {
        return simpleDialog(title || __i18n(`dialog/simple/info`), '<i class="fa-solid fa-circle-info"></i>', 'color-blue', message, buttonLabel || __i18n('button/close'));
    };

    _chmDialog.share = function(message, title, buttonLabel) {
        return simpleDialog(title || __i18n(`dialog/simple/share`), '<i class="fa-solid fa-share"></i>', 'color-blue', message, buttonLabel || __i18n('button/close'));
    };

    _chmDialog.confirm = function(message, options, dialogOptions) {
        return new Promise(function(resolve, reject) {
            let isConfirmed;

            options = $.extend({
                title: false,
                icon: false,
                buttonYes: __i18n('button/yes'),
                buttonNo: __i18n('button/no'),
                yesIsPrimary: true
            }, options);

            isConfirmed = false;

            dialogOptions = $.extend(dialogOptions || {}, {
                title: options.title ? `<span class="text-yellow"><i class="fa-solid fa-clipboard-question"></i></span> ${options.title}` : false,
                icon: options.icon,
                content: message,
                buttons: [
                    {
                        action: () => {
                            isConfirmed = true;
                        },
                        label: options.buttonYes,
                        primary: options.yesIsPrimary
                    },
                    {
                        label: options.buttonNo,
                        primary: !options.yesIsPrimary
                    }
                ],
                afterClose: function(fromBack) {
                    if (fromBack) {
                        return;
                    }
                    if (isConfirmed) {
                        resolve();
                    } else {
                        reject();
                    }
                }
            });            

            chmDialog(dialogOptions);
        });
    };

    _chmDialog.prompt = function(options, dialogOptions) {
        return new Promise(function(resolve) {
            options = $.extend({
                title: false,
                prompt: '',
                value: '',
                type: 'text'
            }, options);

            if (!options.value) {
                options.value = '';
            }
            options.value = String(options.value).trim();

            ScoreTrekBattle.Template.render('dialog/prompt', {
                prompt: options.prompt,
                inputValue: __escapeHTML(options.value),
                inputType: options.type
            }).then(promptView => {
                var $input, value;

                $input = promptView.$view.find('[data-id="promptInput"]');
                value = null;

                dialogOptions = $.extend(dialogOptions || {}, {
                    title: options.title,
                    content: promptView.$view,
                    buttons: [
                        {
                            action: () => {
                                value = String($input.val()).trim();
                            },
                            label: __i18n('button/apply'),
                            primary: true
                        },
                        {
                            label: __i18n('button/cancel')
                        }
                    ],
                    afterClose: function(fromBack) {
                        if (fromBack) {
                            return;
                        }
                        resolve(value);
                    },
                    onShow: function() {
                        $input.focus().select();
                    }
                });

                chmDialog(dialogOptions);
            });
        });
    };

    $(document).on('focusin', function(event) {
        var currentDialog, $closestDialog;

        if (dialogStack.length === 0) {
            return;
        }
        
        currentDialog = dialogStack[dialogStack.length - 1];

        $closestDialog = $(event.target).closest('.dialog');

        if (!currentDialog.$dialog.is($closestDialog)) {
            currentDialog.$dialog.focus();
        }
    });

    $(window).on('resize', function() {
        dialogStack.forEach(dialog => {
            dialog.update(true);
        });
    });

    return _chmDialog;
})();